// extracted by mini-css-extract-plugin
export default {"formTitle":"FormHeader_formTitle__d3oL9","alert":"FormHeader_alert__LWS4F","alertDanger":"FormHeader_alertDanger__lX7JM"};